import { Currency } from '@/core/currency/interfaces';

const ZMW: Currency = {
    name: 'Zambian Kwacha',
    demonym: 'Zambian',
    majorSingle: 'Kwacha',
    majorPlural: 'Kwacha',
    codeNumeric: '967',
    symbol: 'ZK',
    symbolNative: 'ZK',
    minorSingle: 'Ngwee',
    minorPlural: 'Ngwee',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ZMW',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ZMW;
